$(document).ready(function () {
  const BUILD_A_BOX_URL_PATH =
    "/a/account/custom-tools/dynamic-box?product=15412679016722";
  const BOX_SIZE_URL_PATH = "/pages/choose-schedule";

  const metaObjectToCookieMap = window.freeOffers.reduce((map, freeOffer) => {
    map.set(freeOffer.slug, freeOffer["discount_code"]);
    return map;
  }, new Map());

  function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
      sURLVariables = sPageURL.split("&"),
      sParameterName,
      i;

    for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split("=");

      if (sParameterName[0] === sParam) {
        return sParameterName[1] === undefined
          ? true
          : decodeURIComponent(sParameterName[1]);
      }
    }
    return false;
  }

  // Listen for user's selection
  $("input[name='offer-value']").on("click", function () {
    var offerChoice = $("input[name='offer-value']:checked").val();

    onFreebieSelected(offerChoice);

    $(".continueButton").addClass("shake-action");
    setTimeout(function () {
      $(".continueButton").removeClass("shake-action");
    }, 1000);
  });

  function onFreebieSelected(offerChoice) {
    if (offerChoice === "affiliate") {
      // This only happens if the user has an affiliate discount code and then selects a different offer.
      // and then selects the affiliate offer again.
      localStorage.setItem("box-offer", "affiliate");
      window.discountManager.setDiscountCode("affiliate");
      // window.discountManager.clearDiscountCookie();
      // const affilateDiscount = window.discountManager.getAffilateDiscount();
      // window.discountManager.setDiscountCode(affilateDiscount);
    } else {
      const discountInfo = window.discountManager.discountCookieToInfoMap.get(offerChoice);
      // Same map-miss guard as selectDefaultCard: an offer key the rendered
      // map doesn't carry must not throw here either — this runs at the end of
      // setDefaults(), so a throw would leave the continue button unbound.
      if (!discountInfo) return;
      localStorage.setItem("box-offer", discountInfo.name);
      window.discountManager.setDiscountCode(discountInfo.urlPath);
    }
  }

  function setupAffilateDiscountCard() {
    const affilateCard = $(".sub-select-card.affiliate");
    affilateCard.removeClass("hidden");
    const nameElem = affilateCard.find("[data-affiliate-property='name'] span");
    const descriptionElem = affilateCard.find("[data-affiliate-property='description'] span");

    descriptionElem.text("Your promotional discount will apply at checkout.");
    nameElem.text("Special Promo");

    $(".sub-select-card.affiliate input").prop(
      "checked",
      true
    );
    onFreebieSelected('affiliate');

  }

  // First offer key in the map whose card is rendered on this page. The map
  // holds every published offer (WELCOME20 included) but the template renders
  // only some of them as cards, so a key is usable as a default only if a
  // matching .sub-select-card exists.
  function firstRenderedOfferKey(offerMap) {
    var found;
    offerMap.forEach(function (info, code) {
      if (found) return;
      if ($(".sub-select-card." + (info.name || "") + " input").length > 0) {
        found = code;
      }
    });
    return found;
  }

  function selectDefaultCard() {

    var free_offer_param = getUrlParameter("freeoffer"); // Is this parameter actually ever set?
    // `getCookie(...)` used to be a BARE call. This file defines no getCookie;
    // the only one it could resolve to is the page-global `var getCookie` in
    // sections/discount-banner.liquid — present on page.box-join-offer
    // (/pages/choose-offer), ABSENT on page.box-free-offer
    // (/pages/choose-your-free-offer). On the latter it threw a ReferenceError
    // for every shopper reaching the non-affiliate branch (anyone with no
    // discount_code cookie); setDefaults() aborted before binding the
    // .continueButton click handler, leaving Continue dead. DiscountManager
    // owns the cookie read — use it, and drop the hidden dependency on a
    // sibling section's inline script.
    var discountCodeCookieVal = window.discountManager.getCookie("discount_code");
    const storedBoxOffer = localStorage.getItem("box-offer");

    // Priority: URL | COOKIE | STORAGE | DEFAULT. Default is the ACTIVE
    // smoked-salmon offer (matches the single-flow funnel default) — the old
    // FREEHALIBUT default is a dropped offer on an archived product (PR B).
    // Offer keys are upper-case; email links arrive as ?freeoffer=freescallops
    // as often as ?freeoffer=FREESCALLOPS. Normalize the same way the
    // single-flow funnel does (seafood-plan-single-flow.js) so a lowercase
    // link selects its card instead of falling through to the default.
    var defaultDiscountVal =
      (typeof free_offer_param === "string" && free_offer_param.toUpperCase()) ||
      discountCodeCookieVal ||
      metaObjectToCookieMap.get(storedBoxOffer || "") ||
      "FREESMOKEDSALMON";
    // Dropped/dead offer keys (old links, stale cookies) resolve to the
    // active fallback offer instead of dereferencing a missing map entry.
    if (typeof window.discountManager.resolveOfferKey === "function") {
      defaultDiscountVal =
        window.discountManager.resolveOfferKey(defaultDiscountVal) || defaultDiscountVal;
    }
    // An offer key the rendered map doesn't carry — an unknown or retired
    // ?freeoffer= value, a stale cookie — falls back to the ACTIVE default
    // rather than dereferencing a missing entry. If even that default is
    // missing from the map (offer unpublished in Admin), fall back to the
    // first offer that actually has a card on this page: leaving
    // currentDiscount unset would make Continue call applyDiscount(undefined),
    // which clears the shopper's real discount_code cookie.
    const offerMap = window.discountManager.discountCookieToInfoMap;
    if (!offerMap.has(defaultDiscountVal)) {
      defaultDiscountVal = "FREESMOKEDSALMON";
    }
    if (!offerMap.has(defaultDiscountVal)) {
      defaultDiscountVal = firstRenderedOfferKey(offerMap);
    }
    const discountInfo = offerMap.get(defaultDiscountVal);
    // The setDiscountCode read used to sit OUTSIDE this guard, so a map miss
    // threw on `undefined.urlPath` and aborted setDefaults() before the
    // continue-button handler bound: a dead page, not a fallback.
    if (discountInfo) {
      window.discountManager.setDiscountCode(discountInfo.urlPath);
      // Update the UI
      $(".sub-select-card." + (discountInfo.name || "") + " input").prop(
        "checked",
        true
      );
    }
    onFreebieSelected(window.discountManager.currentDiscount);
  }

  function setDefaults() {
    if (window.discountManager.hasAffiliateCode()) {
      setupAffilateDiscountCard();
    } else {
      selectDefaultCard();
    }

    const isBuildABox = localStorage.getItem("box-food") === "custom";

    $(".mainButtonCTA").text(
      isBuildABox ? "Continue to build-a-box" : "Continue to Box Size >>"
    );

    $(".continueButton").on("click", async function () {
      const $btn = $(this);
      $btn
        .find("span")
        .after(
          '<div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>'
        );

      $btn.find("span").hide();
      $btn.prop("disabled", true);

      try {
        // clear the cart b/c it might have old "freebie" products that are no longer free.
        await window.NttUtils.clearCart();

        await window.discountManager.applyCurrentDiscount();

        // Add the family owens insert to the cart
        await window.NttUtils.addItemsToCart([{ id: "50989025853714", quantity: 1 }]);

        window.location = isBuildABox ? BUILD_A_BOX_URL_PATH : BOX_SIZE_URL_PATH;
      } catch (error) {
        // The add aborted (commonly an iOS in-app-browser fetch abort) and
        // addItemsToCart rejected. Restore the button — it was disabled with a
        // spinner — so the shopper can retry instead of being stuck on a dead,
        // forever-spinning button.
        $btn.find(".lds-ellipsis").remove();
        $btn.find("span").show();
        $btn.prop("disabled", false);
        window.NttUtils.showCartError(
          "We couldn't continue. Please check your connection and try again.",
          { onRetry: function () { $btn.trigger("click"); } },
        );
      }

    });

  }

  function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
      sURLVariables = sPageURL.split("&"),
      sParameterName,
      i;

    for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split("=");

      if (sParameterName[0] === sParam) {
        return sParameterName[1] === undefined
          ? true
          : decodeURIComponent(sParameterName[1]);
      }
    }
    return false;
  }

  $(window).on("unload", function () {
    $("#checkout-button span").show();
    $(".lds-ellipsis").remove();
    $("#checkout-button").prop("disabled", false);
  });

  setDefaults();
});
